// Unpublished Work © 2024 Deere & Company.

import { createContext, ReactElement } from "react";
import { ApplicationError } from "../../router/utils";

export const ErrorContext = createContext<any>(undefined);
export const ErrorProvider = ({
  children,
  initialValue,
}: {
  children: ReactElement;
  initialValue?: ApplicationError;
}) => (
  <ErrorContext.Provider value={initialValue}>{children}</ErrorContext.Provider>
);
